import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CarrinhoComponent } from './../../../carrinho/carrinho.component';
import { Authority } from './../../../shared/config/authority.constants';
import { ProdutoSugerido } from './../../../shared/models/produto-sugerido.model';
import { AccountService } from './../../../shared/services/account.service';
import { LoginService } from './../../../shared/services/login.service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { UtilsCompraService } from 'src/app/shared/services/utils-compra.service';
import { NotaFiscalService } from 'src/app/shared/services/nota-fiscal.service';
import { NotificationComponent } from '../notification/notification.component';
import { INotaFiscal } from 'src/app/shared/models/nota-fiscal.model';
import { HttpResponse } from '@angular/common/http';
import { Status } from 'src/app/shared/models/status.model';
import dayjs from 'dayjs';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-topnav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.scss'],
    standalone: true,
    imports: [MatIconButton, MatTooltip, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, RouterLink, NgClass, MatBadge, TranslateModule]
})
export class TopnavComponent implements OnInit {

    produtoscarrinho: ProdutoSugerido[] = [];
    numProdCar;
    numRenova = [];
    numAguardando = [];
    isLoading = false;
    public pushRightClass: string;
    active: boolean;
    constructor(public router: Router,
        public translate: TranslateService,
        public dialog: MatDialog,
        private loginService: LoginService,
        private accountService: AccountService,
        private $localStorage: LocalStorageService,
        private $sessionStorage: SessionStorageService,
        private utilsCompraService: UtilsCompraService,
        protected notaFiscalService: NotaFiscalService
    ) {
        this.router.events.subscribe(val => {
            if (val instanceof NavigationEnd && window.innerWidth <= 992 && this.isToggled()) {
                this.toggleSidebar();
            }
        });
    }

    loadAll(): void {
        this.isLoading = true;
        this.notaFiscalService.notification().subscribe(
          (res: HttpResponse<INotaFiscal[]>) => {
            const newData = res.body.map(x => {
                return {
                  ...x,
                  produtor: `${x.user.firstName.toLowerCase()}${x.user.lastName.toLowerCase()}`
                };
              })

            let needRenova = newData.filter(x => x.status === Status.APROVADA && x.timestamp.diff(dayjs(), 'year'));
            let needResposta = newData.filter(x => x.status === Status.RESPONDIDO);
            this.notaFiscalService.carRenovaSignal.set(needRenova);
            this.notaFiscalService.carAguardandoSignal.set(needResposta);
            this.numRenova  = this.notaFiscalService.carRenovaSignal();
            this.numAguardando = this.notaFiscalService.carAguardandoSignal();

          },
          () => {
            this.isLoading = false;
          }
        );
      }

    ngOnInit() {
        this.loadAll();
        this.utilsCompraService.produtosCarrinho.subscribe(num => this.numProdCar = num);
        this.produtoscarrinho = this.utilsCompraService.getCarrinho();
        this.pushRightClass = 'push-right';
        if (this.translate.currentLang === 'pt') {
            this.active = true;
            return;
        }
        this.active = false;
    }

    navigateHome() {
        if(this.accountService.hasAnyAuthority(Authority.PRODUTOR)) this.router.navigate(["/dashboard"]);
        if(this.accountService.hasAnyAuthority(Authority.COMPRADOR)) this.router.navigate(["/dashboard-comprador"]);
        if(this.accountService.hasAnyAuthority(Authority.ADMIN)) this.router.navigate(["/dashboard-adm"]);
    }

    isProdutor() {
        return this.accountService.hasAnyAuthority(Authority.PRODUTOR);
    }

    isComprador() {
        return this.accountService.hasAnyAuthority(Authority.COMPRADOR);
    }

    isAdm() {
        return this.accountService.hasAnyAuthority(Authority.ADMIN);
    }

    setActive() {
        if (this.translate.currentLang === 'pt') {
            this.translate.use('en');
        } else {
            this.translate.use('pt');
        }
        this.active = !this.active;
    }

    isToggled(): boolean {
        const dom: Element = document.querySelector('body');
        return dom.classList.contains(this.pushRightClass);
    }

    toggleSidebar() {
        const dom: any = document.querySelector('body');
        dom.classList.toggle(this.pushRightClass);
    }

    onLoggedout() {
        localStorage.removeItem('isLoggedin');
        this.loginService.logout();
        this.router.navigate(['/site']);
    }

    openDialogCarrinho() {
        this.dialog.open(CarrinhoComponent, {
            data: {calcProfile: ''}
        });
    }

    openDialogNotification() {
        this.dialog.open(NotificationComponent, {
        }).afterClosed().subscribe(() => this.loadAll());
    }
}
